import React from "react";

import IndividualExperience from "./IndividualExperience";
import Listing from "../Listing/Listing";

const ExperienceListing = () => {
  const experiences = [
    {
      from: "July 2019",
      to: "May 2020",
      company: "KLASS Engineering & Solutions",
      position: "Software Engineer (Video Analytics)",
      type: "Internship",
      description:
        "Developed an all-in-one machine learning platform, catered towards simplifying the process of labelling, training, assessing and visualising a model from scratch.",
      stack: [
        "React",
        "Docker",
        "Python",
        "Go",
        "AntDesign",
        "Cypress",
        "Redis",
      ],
    },
    {
      from: "May 2022",
      to: "August 2022",
      company: "KLASS Engineering & Solutions",
      position: "Software Engineer (Video Analytics)",
      type: "Contract",
      description:
        "Engineered a robust person reidentification pipeline and deployed it via Kubernetes (k3s) to support seamless, horizontal deployment in an air-gapped setting.",
      stack: [
        "Kubernetes",
        "Docker",
        "Python",
        "Machine Learning",
        "Milvus"
      ],
    },
    {
      from: "August 2023",
      to: "April 2024",
      company: "Singapore Management University",
      position: "Computational Thinking Teaching Assistant",
      type: "Contract",
      description:
        "Provided guidance to over 50 students across 2 semesters on fundamental data structures and algorithms.",
      stack: [],
    },
    {
      from: "May 2024",
      to: "December 2024",
      company: "Accenture (Southeast Asia)",
      position: "Software Engineer",
      type: "Internship",
      description:
        "Contributed to the development and migration of the Citizen Disbursement IT platform to a cloud-based environment.",
      stack: [
        "Spring Boot",
        "Spring Batch",
        "AWS"
      ],
    },
    {
      from: "Jan 2025",
      to: "Jun 2025",
      company: "Government of Singapore Investment Corporation (GIC)",
      position: "Software Engineer",
      type: "Internship",
      description:
        "Developed functionalities for traders in the Portfolio Execution Group to minimise manual intervention in trade execution.",
      stack: [
        "Java",
        "Portware",
        "AWS"
      ],
    },
    {
      from: "Jun 2025",
      to: "Jan 2026",
      company: "TikTok",
      position: "Software Engineer",
      type: "Internship",
      description:
        "Developing cool features with the Global LIVE Wallet team!",
      stack: [
        "Go",
        "TypeScript",
      ],
    },

    {
      from: "Jan 2026",
      to: "Current",
      company: "Singapore Management University",
      position: "IT Solutions Architecture Teaching Assistant",
      type: "Contract",
      description:
        "Providing guidance to over 50 students across 2 sections on solution architecting with AWS in my final semester with SMU!",
      stack: [],
    },
  ];

  return (
    <Listing
      list={experiences}
      title={"Experiences"}
      Component={IndividualExperience}
    />
  );
};

export default ExperienceListing;
